import { useState, useEffect } from 'react';

const imgTest = ['.jpg', '.jpeg', '.png', '.bmp', '.gif', 'heic'];

const useSortAttachmentsByExtensions = ({ attachments }) => {
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    let newImages = [];
    let newFiles = [];

    if (attachments?.length > 0) {
      attachments.forEach((attach) => {
        const isImg = imgTest.some((imgExt) =>
          attach.fileName.toLowerCase().endsWith(imgExt)
        );

        isImg ? newImages.push(attach) : newFiles.push(attach);
      });
    }

    setImages(newImages);
    setFiles(newFiles);
  }, [attachments]);

  return { images, files };
};

export default useSortAttachmentsByExtensions;
